import { modularScale as modularScale$1 } from 'polished';
import { scales } from './scales.js';

/**
 * Collection of design tokens for font sizes, utilizing a modular scale for consistent and
 * harmonious typography sizing.
 */ const fontSizes = {
    '2xs': modularScale(-2),
    xs: modularScale(-1.5),
    sm: modularScale(-1),
    md: modularScale(-0.5),
    lg: modularScale(0),
    xl: modularScale(1),
    '2xl': modularScale(2),
    '3xl': modularScale(4),
    '4xl': modularScale(6),
    '5xl': modularScale(8),
    '6xl': modularScale(10),
    '7xl': modularScale(12)
};
/**
 * Returns a font size based on the modular scale using the base font size and the provided scale
 * ratio.
 *
 * @param steps - The number of steps to move up or down the modular scale.
 */ function modularScale(steps) {
    return modularScale$1(steps, '1rem', scales.typography);
}

export { fontSizes };
//# sourceMappingURL=font-sizes.js.map
